const isMacOs = window.navigator.appVersion.indexOf('Mac') !== -1;

export { isMacOs };
